import React from 'react';
import styled from 'styled-components';
import { Table, Button, Dropdown } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import EditIcon from '../../../images/edit_icon.png';
import { COMPLEX_PAUSE_ID } from '../../../constants/appConstants';
import ChangeStatusPauseButton from './ChangeStatusPauseButton';

const ComplexTable = ({
  complex,
  confirmDeleting,
  setIsChangeComplexStartDate,
  transformedComplexStatus,
  onStatusChange,
  changeComplexPauseStatus,
}) => {
  const [isDayOnPauseTomorrow, setIsDayOnPauseTomorrow] = React.useState(false);
  const [isPauseTakeOffTomorrow, setIsPauseTakeOffTomorrow] = React.useState(false);

  return (
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>ID курса</Table.HeaderCell>
          <Table.HeaderCell>Ссылка на сделку в амо</Table.HeaderCell>
          <Table.HeaderCell>Дата старта курса</Table.HeaderCell>
          <Table.HeaderCell>Длительность курса</Table.HeaderCell>
          <Table.HeaderCell>Количество дней на паузе</Table.HeaderCell>
          <Table.HeaderCell>Дата конца курса</Table.HeaderCell>
          <Table.HeaderCell>Статус</Table.HeaderCell>
          <Table.HeaderCell>Пауза</Table.HeaderCell>
          <Table.HeaderCell>Редактирование</Table.HeaderCell>
          <Table.HeaderCell>Удаление</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell>{complex.id}</Table.Cell>
          <Table.Cell>
            <a href={`https://youslim.amocrm.ru/contacts/detail/${complex.amo}`}>Ссылка на амо</a>
          </Table.Cell>
          <Table.Cell>
            <Button onClick={() => setIsChangeComplexStartDate(true)} basic color="blue">
              {complex.start_date || 'Не выбрана'}
            </Button>
          </Table.Cell>
          <Table.Cell>{complex.duration}</Table.Cell>
          <Table.Cell>
            {complex.status !== COMPLEX_PAUSE_ID
              ? (isPauseTakeOffTomorrow &&
                  complex &&
                  complex.finished_at &&
                  `Курс будет снят с паузы ${complex.finished_at}`) ||
                (isDayOnPauseTomorrow &&
                  complex &&
                  complex.paused_at &&
                  `Курс будет на паузе ${complex.paused_at}`) ||
                complex.days_left ||
                'Курс не был на паузе'
              : 'Курс на паузе'}
          </Table.Cell>
          <Table.Cell>{complex.end_date || 'Не выбрана'}</Table.Cell>
          <Table.Cell>
            <Dropdown
              placeholder="Выберите статус"
              fluid
              selection
              disabled={
                complex.status === COMPLEX_PAUSE_ID ||
                isDayOnPauseTomorrow ||
                isPauseTakeOffTomorrow
              }
              options={transformedComplexStatus}
              defaultValue={complex.status}
              onChange={(e, data) => onStatusChange(complex.id, data)}
            />
          </Table.Cell>
          <Table.Cell>
            <ChangeStatusPauseButton
              complex={complex}
              setIsDayOnPauseTomorrow={setIsDayOnPauseTomorrow}
              changeComplexPauseStatus={changeComplexPauseStatus}
              setIsPauseTakeOffTomorrow={setIsPauseTakeOffTomorrow}
              nonePauseText="Курс не был на паузе"
            />
          </Table.Cell>
          <Table.Cell>
            <EditButton to="/">
              <Img src={EditIcon} alt="edit" />
            </EditButton>
          </Table.Cell>
          <Table.Cell>
            <DeleteButton onClick={(event) => confirmDeleting(event, complex.id, complex.name)}>
              x
            </DeleteButton>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
};

export default ComplexTable;

const DeleteButton = styled.div`
  width: 25px;
  height: 25px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  background: #db2828;
  color: #fff;
  border: none;
  border-radius: 5px;
  text-transform: uppercase;
  &:hover {
    background: #d01919;
    border: 1px solid #000542;
  }
  @media (max-width: 992px) {
    width: 20px;
    height: 20px;
  }
`;

const EditButton = styled(Link)`
  background: #fff;
  width: 25px;
  height: 25px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #fff;
  border: 1px solid #000542;
  border-radius: 5px;
  text-transform: uppercase;
  &:hover {
    background: #17ade3;
    border: 1px solid #000542;
  }
  @media (max-width: 992px) {
    width: 20px;
    height: 20px;
  }
`;

const Img = styled.img`
  width: 15px;
  height: 15px;
`;



// WEBPACK FOOTER //
// ./src/Components/Menus/ControlUsers/ComplexTable.jsx